<template>
  <div id="edit_member">
    <div class="page-header header-filter" data-parallax="true" style="background-image: url('static/img/member.jpg'); height:50vh; background-position:0px 27%">
      <div class="container">
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto">
                <div class="brand text-center">
                  <h1 id="hide_edit">(編輯)中心成員</h1>
                  <h3 class="title text-center">(Edit)Personnel</h3>
                </div>
            </div>
          </div>
      </div>
    </div>
    <div class="main">
        <div class="container">          
            <div class="progress" style="height: 10px;" v-if="prossVal !=0">
                <div class="progress-bar" role="progressbar" :style="{width: prossVal + '%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{prossVal}}%</div>
            </div>
          <div class="section">
            <button class="btn btn-social btn-fill btn-behance" @click="save_data">
                <span class="material-icons mr-2">save_alt</span> 儲存
            </button>
            <button class="btn btn-social btn-fill btn-tumblr" @click="cancel_edit">
                <span class="material-icons mr-2">keyboard_return</span> 取消編輯
            </button>
            <!-- 主要成員 -->
            <template v-for="(item, index) in professor">
              <table class="table table-bordered" :key="'professor' + item.team_id">
                <thead class="thead-light">
                  <tr>
                    <th colspan="2">
                      <button v-if="item.del == 0" class="btn btn-link btn-twitter" @click="title_del(index)">
                          <span class="material-icons mr-2">remove_circle_outline</span>刪除全部
                      </button>
                      <button v-else class="btn btn-link btn-twitter" @click="title_cancel_del(index)">
                          <span class="material-icons mr-2">delete_sweep</span>cancel delete
                      </button>
                      <button  class="btn btn-link btn-facebook" data-toggle="collapse" :data-target="'.title' + item.team_id">
                          <span class="material-icons mr-2">list</span>摺疊
                      </button>
                    </th>
                  </tr>
                </thead>
                <tr>
                  <td>
                    <template v-if="item.del == 0">
                        <label class="btn btn-info">
                          <input type="file" class="custom-file-input" style="display: none;" id="img-upload" accept="image/*" @change="uploadImg($event, index, 'professor')" />
                          <i class="fa fa-photo"></i> 上傳圖片
                        </label>
                        <img style="width:50%;" :src="item.pic" />
                    </template>
                    
                    <input type="text" class="form-control text-danger font-italic" v-model="item.pic" readonly v-else>
                  </td>
                  <td>
                    中文姓名：
                    <input type="text" class="form-control" v-model="item.name_cht" v-if="item.del == 0">
                    <input type="text" class="form-control text-danger font-italic" v-model="item.name_cht" readonly v-else>
                    英文姓名：
                    <input type="text" class="form-control" v-model="item.name_eng" v-if="item.del == 0">
                    <input type="text" class="form-control text-danger font-italic" v-model="item.name_eng" readonly v-else>
                    信箱：
                    <input type="text" class="form-control" v-model="item.email" v-if="item.del == 0">
                    <input type="text" class="form-control text-danger font-italic" v-model="item.email" readonly v-else>
                  </td>
                </tr>
                <template v-for="(job_item, job_index) in item.job_title_list">
                  <tr :class="'title' + item.team_id" class="collapse show" :key="'job' + job_index">
                    <td style="width:80px">
                      <button v-if="job_item.del == 0" class="btn btn-link btn-twitter" @click="list_del(index, job_index, 'job_title')">
                          <span class="material-icons mr-2">remove_circle_outline</span>刪除稱號
                      </button>
                      <button v-else class="btn btn-link btn-twitter" @click="list_cancel_del(index, job_index, 'job_title')">
                          <span class="material-icons mr-2">delete_sweep</span>取消刪除
                      </button>
                    </td>
                    <td>
                      中文稱號 {{ job_item.id }}：
                      <input type="text" class="form-control" v-model="job_item.job_title_cht" v-if="job_item.del == 0">
                      <input type="text" class="form-control text-danger font-italic" v-model="job_item.job_title_cht" readonly v-else>
                      英文稱號 {{ job_item.id }}：
                      <input type="text" class="form-control" v-model="job_item.job_title_eng" v-if="job_item.del == 0">
                      <input type="text" class="form-control text-danger font-italic" v-model="job_item.job_title_eng" readonly v-else>
                    </td>
                  </tr>
                </template>
                <tr :class="'title' + item.team_id" class="collapse show">
                  <td colspan="2">
                    <button class="btn btn-social btn-fill btn-twitter" @click="add_title(index, 'job_title')">
                      <span class="material-icons mr-2">control_point</span> 增加新稱號
                    </button>
                  </td>
                </tr>
                <template v-for="(pro_item, pro_index) in item.profession_list">
                  <tr :class="'title' + item.team_id" class="collapse show" :key="'pro' + pro_item.id">
                    <td style="width:80px">
                      <button v-if="pro_item.del == 0" class="btn btn-link btn-twitter" @click="list_del(index, pro_index, 'profession')">
                          <span class="material-icons mr-2">remove_circle_outline</span>刪除專業
                      </button>
                      <button v-else class="btn btn-link btn-twitter" @click="list_cancel_del(index, pro_index, 'profession')">
                          <span class="material-icons mr-2">delete_sweep</span>取消刪除
                      </button>
                    </td>
                    <td>
                      中文專業 {{ pro_item.id }}：
                      <input type="text" class="form-control" v-model="pro_item.profession_cht" v-if="pro_item.del == 0">
                      <input type="text" class="form-control text-danger font-italic" v-model="pro_item.profession_cht" readonly v-else>
                      英文專業 {{ pro_item.id }}：
                      <input type="text" class="form-control" v-model="pro_item.profession_eng" v-if="pro_item.del == 0">
                      <input type="text" class="form-control text-danger font-italic" v-model="pro_item.profession_eng" readonly v-else>
                    </td>
                  </tr>
                </template>
                <tr :class="'title' + item.team_id" class="collapse show">
                  <td colspan="2">
                    <button class="btn btn-social btn-fill btn-twitter" @click="add_title(index, 'profession')">
                      <span class="material-icons mr-2">control_point</span> 增加新專業
                    </button>
                  </td>
                </tr>
              </table>
            </template>
            <button class="btn btn-social btn-fill btn-facebook" @click="add_title(0, 'professor')">
                <span class="material-icons mr-2">control_point</span> 增加新人員
            </button>
            <hr>
            <!-- 其他成員 -->
            <table class="table table-bordered">
              <tr class="thead-light">
                <th colspan="3">
                  <button  class="btn btn-link btn-facebook" data-toggle="collapse" data-target=".members">
                      <span class="material-icons mr-2">list</span>折疊
                  </button>
                </th>
              </tr>
              <template v-for="(item, index) in members">
                <tr :key="'members' + index" class="members collapse show">
                  <td>
                    <button v-if="item.del == 0" class="btn btn-link btn-twitter" @click="list_del(index, 0, 'members')">
                        <span class="material-icons">remove_circle_outline</span>刪除
                    </button>
                    <button v-else class="btn btn-link btn-twitter" @click="list_cancel_del(index, 0, 'members')">
                        <span class="material-icons mr-2">delete_sweep</span>取消刪除
                    </button>
                  </td>
                  <td style="width:40%">
                    中文姓名：
                    <input type="text" class="form-control" v-model="item.name_cht" v-if="item.del == 0">
                    <input type="text" class="form-control text-danger font-italic" v-model="item.name_cht" v-else readonly>
                    英文姓名：
                    <input type="text" class="form-control" v-model="item.name_eng" v-if="item.del == 0">
                    <input type="text" class="form-control text-danger font-italic" v-model="item.name_eng" v-else readonly>
                    信箱：
                    <input type="text" class="form-control" v-model="item.email" v-if="item.del == 0">
                    <input type="text" class="form-control text-danger font-italic" v-model="item.email" readonly v-else>
                  </td>
                  <td>
                    所屬單位：
                    <select class="custom-select" v-model="item.team_id" v-if="item.del == 0">
                      <template v-for="item in team_list">
                        <option :value="item.id" :key="'team_id' + item.id">{{ item.text }}</option>
                      </template>
                    </select>
                    <input type="text" class="form-control text-danger font-italic" v-model="item.team_id" v-else readonly>
                    職稱：
                    <select class="custom-select" v-model="item.job_title_eng" v-if="item.del == 0">
                      <template v-for="item in job_title_list">
                        <option :value="item.value" :key="'job_title' + item.id">{{ item.text }}</option>
                      </template>
                    </select>
                    <input type="text" class="form-control text-danger font-italic" v-model="item.job_title_cht" v-else readonly>
                    
                    <!-- <input type="text" class="form-control" v-model="item.pic" v-if="item.del == 0"> -->
                    <template v-if="item.del == 0">
                      <!-- <template v-if="item.pic == 'placeholder'"> -->
                        <label class="btn btn-info">
                          <input type="file" class="custom-file-input" style="display: none;" id="img-upload" accept="image/*" @change="uploadImg($event, index, 'members')" />
                          <i class="fa fa-photo"></i> 上傳圖片
                        </label>
                      <!-- </template>
                      <template v v-else> -->
                        <!-- 照片名稱：<input type="text" class="form-control" v-model="item.pic"> -->
                        <img style="width:20%;" :src="item.pic" />
                      <!-- </template> -->
                    </template>
                    <input type="text" class="form-control" v-model="item.pic" v-else readonly>
                  </td>
                </tr>
              </template>
              <tr>
                <button class="btn btn-social btn-fill btn-facebook" @click="add_title(0, 'members')">
                  <span class="material-icons mr-2">control_point</span> 增加新人員
                </button>
              </tr>
            </table>

            <button class="btn btn-social btn-fill btn-behance" @click="save_data">
                <span class="material-icons mr-2">save_alt</span> 儲存
            </button>
            <button class="btn btn-social btn-fill btn-tumblr" @click="cancel_edit">
                <span class="material-icons mr-2">keyboard_return</span> 取消編輯
            </button>
          </div>
        </div>
    </div>
    
  </div>
</template>

<script>
import axios from "axios";
import EXIF from "exif-js";

export default {
  name: "edit_member",
  props: [],
  data() {
    return {
      professor: [],
      members:[],
      // postdoctoral:[],
      // researcher: [],
      // assistant: [],
      job_title_list: [
          {id: 1, text: '博士後研究員', value: 'Postdoctoral Researcher'},
          {id: 2, text: '專任研究員', value: 'Researcher'},
          {id: 3, text: '專任研究助理', value: 'Assistant'},
          {id: 4, text: '顧問', value: 'Consultant'},
          {id: 5, text: '博士級研究生', value: 'Ph. D.'}
      ],
      team_list: [],
      imgFile: [],
      imgNumLimit: 1,
      imgString: [],
      prossVal: 0     // 進度條
    };
  },
  methods: {
    getprofessorInfo: function(){
      var vm = this;
      // console.log('getprofessorInfo')s
       axios
          .get(`/api/getprofessorInfo`)
          .then(res => {
            // console.log(res.data);
            // vm.professor = res.data;
            var data = res.data.data;
            for(var i = 0; i < data.length; i++){
              // console.log(data[i])
              // 給其他人員，選擇所屬單位使用
              vm.team_list.push({
                id: data[i].team_id,
                text: data[i].name_cht
              })
              // 稱號
              var job_title_list = []
              var job_title_cht = data[i].job_title_cht.split('/');
              var job_title_eng = data[i].job_title_eng.split(';');
              
              for(var a = 0; a < job_title_eng.length ;a++){
                job_title_list.push({
                  id: a + 1,
                  del: 0,
                  job_title_cht: job_title_cht[a],
                  job_title_eng: job_title_eng[a],
                })
              }
              // 專業領域
              var profession_list = []
              var profession_cht = data[i].profession_cht.split(';');
              var profession_eng = data[i].profession_eng.split(';');
              
              for(var b = 0; b < profession_cht.length; b++){
                profession_list.push({
                  id: b + 1,
                  del: 0,
                  profession_cht: profession_cht[b],
                  profession_eng: profession_eng[b]
                })
              }
              //==============================================
            
              //==============================================
              
              vm.professor.push({
                del: 0,
                id: data[i].id,
                team_id: data[i].team_id,
                name_cht: data[i].name_cht,
                name_eng: data[i].name_eng,
                email: data[i].email,
                job_title_list: job_title_list,
                pic: data[i].img,
                profession_list: profession_list
              })
            }
            // 給其他人員，選擇所屬單位使用
            vm.team_list.push({
              id: 99,
              text: '其他'
            })
          })
          .catch(err => {
            console.log(err);
          });
    },
    getmembersInfo: function(){
      var vm = this;
      // console.log('getmembersInfo')
       axios
          .get(`/api/getmembersInfo`)
          .then(res => {
            // console.log(res.data);
            var data = res.data.data;
            data.forEach(function(item) {
              vm.members.push({
                id: item.id,
                team_id: item.team_id,
                del: 0,
                name_cht:  item.name_cht,
                name_eng: item.name_eng,
                email: item.email,
                job_title_cht: item.job_title_cht,
                job_title_eng: item.job_title_eng,
                pic: item.img,

              })
            });
          //   data.forEach(function(item) {
          //     if(item.job_title_cht == "博士後研究員"){
          //       vm.postdoctoral.push(item);
          //     }
          //     if (item.job_title_cht =="專任研究員"){
          //         vm.researcher.push(item);
          //     }
          //     if (item.job_title_cht =="專任研究助理"){
          //         vm.assistant.push(item);
          //     }
          // });
            
          })
          .catch(err => {
            console.log(err);
          });
    },
    add_title: function(index, name){
      // 主要人員
      if(name =='professor'){
        var data_title_len = this.professor.length;
        var last_team_id = this.professor[data_title_len -1].team_id;

        this.professor.push({
          del: 0,
          id: null,
          team_id: last_team_id + 1,
          name_cht: '',
          name_eng: '',
          job_title_list: [{
              id: 1,
              del: 0,
              job_title_cht: '',
              job_title_eng: '',
            }
          ],
          pic: 'placeholder',
          profession_list: [{
            id: 1,
            del: 0,
            profession_cht: '',
            profession_eng: ''
          }]
        })
      }
      // 其他人員
      if(name == 'members'){
        var data_title_len = this.members.length;
        var last_team_id = this.members[data_title_len -1].id;

        this.members.push({
          id: null,
          team_id: 99,
          del: 0,
          name_cht:  '',
          name_eng: '',
          job_title_cht: '',
          job_title_eng: 'Researcher',
          pic: 'placeholder',

        })
      }
      // 主要人員 稱號
      if(name == 'job_title'){
        this.professor[index].job_title_list.push({
          del: 0,
          id: this.professor[index].job_title_list.length + 1,
          job_title_cht: '',
          job_title_eng:''
        })
      }
      // 主要人員 專業
      if(name == 'profession'){
        this.professor[index].profession_list.push({
          del: 0,
          id: this.professor[index].profession_list.length + 1,
          profession_cht: '',
          profession_eng:''
        })
      }
    },
    title_del: function(index){
      this.professor[index].del = 1;
      // 讓小標都標示為刪除
      for(var i = 0; i < this.professor[index].job_title_list.length; i++){
          this.professor[index].job_title_list[i].del = 1;
      }
      for(var j = 0; j < this.professor[index].profession_list.length; j++){
          this.professor[index].profession_list[j].del = 1;
      }
    },
    title_cancel_del: function(index){
      this.professor[index].del = 0;
      // 讓小標都標示為未刪除
      for(var i = 0; i < this.professor[index].job_title_list.length; i++){
          this.professor[index].job_title_list[i].del = 0;
      }
      for(var j = 0; j < this.professor[index].profession_list.length; j++){
          this.professor[index].profession_list[j].del = 0;
      }
    },
    list_del: function(index, sub_index, sub_name){
      if(sub_name == 'job_title'){
        this.professor[index].job_title_list[sub_index].del = 1;
      }
      if(sub_name == 'profession'){
        this.professor[index].profession_list[sub_index].del = 1;
      }
      if(sub_name == 'members'){
        this.members[index].del = 1;
      }
    },
    list_cancel_del: function(index, sub_index, sub_name){
      if(sub_name == 'members'){
        this.members[index].del = 0;
      }
      if(this.professor[index].del != 1){
          if(sub_name == 'job_title'){
            this.professor[index].job_title_list[sub_index].del = 0;
          }
          if(sub_name == 'profession'){
            this.professor[index].profession_list[sub_index].del = 0;
          }
      }
      else{
          alert('大標題已被標示為刪除');
      }
    },
    async save_data(){
      var vm = this;
      var success_professor = false;
      var success_members = false;
      // 儲存 教授
      var save_professor = [];

      for(var i = 0; i < this.professor.length; i++){
        var job_title_list = this.professor[i].job_title_list;
        var profession_list = this.professor[i].profession_list;
        var job_title_cht = ''
        var job_title_eng = ''
        var profession_cht = ''
        var profession_eng = ''

        job_title_list.forEach(function(item, idx){
          if(item.del == 0){
            if (idx === job_title_list.length - 1){ 
              job_title_cht += item.job_title_cht;
              job_title_eng += item.job_title_eng;
            }
            else{
              job_title_cht += item.job_title_cht + '/';
              job_title_eng += item.job_title_eng + ';';
            }
            
          }
        })

        profession_list.forEach(function(item, idx){
          if(item.del == 0){
            if (idx === profession_list.length - 1){
              profession_cht += item.profession_cht;
              profession_eng += item.profession_eng;
            }
            else{
              profession_cht += item.profession_cht + ';';
              profession_eng += item.profession_eng + ';';
            }
            
          }
        })
        // save_professor.push({
        //   id: this.professor[i].id,
        //   team_id: this.professor[i].team_id,
        //   name_cht: this.professor[i].name_cht,
        //   name_eng: this.professor[i].name_eng,
        //   job_title_cht: job_title_cht,
        //   job_title_eng: job_title_eng,
        //   img: this.professor[i].pic,
        //   profession_cht: profession_cht,
        //   profession_eng: profession_eng,
        //   del: this.professor[i].del     
        // });
        await vm.save_professor({
          id: vm.professor[i].id,
          team_id: vm.professor[i].team_id,
          name_cht: vm.professor[i].name_cht,
          name_eng: vm.professor[i].name_eng,
          email: vm.professor[i].email,
          job_title_cht: job_title_cht,
          job_title_eng: job_title_eng,
          img: vm.professor[i].pic,
          pic: vm.professor[i].name_cht,
          profession_cht: profession_cht,
          profession_eng: profession_eng,
          del: vm.professor[i].del     
        })
        
      }
      success_professor = true;
      // console.log(save_professor)
      // save_professor.forEach(function(item){
      //   axios
      //   .post(`${process.env.API_PATH}/api/saveprofessorInfo`, save_professor)
      //   .then(res => {
      //     if(res.status == 200){
      //       // vm.$router.push("/about/member");
      //       success_professor = true;
      //     }
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
      // })
      
      

      // 儲存 其他人
      var save_members = []
      for(var j = 0; j < this.members.length; j++){
        var job_title_eng = this.members[j].job_title_eng;
        var job_title_cht = ''
        vm.job_title_list.forEach(function(item){
          if(item.value.indexOf(job_title_eng)>=0){
            job_title_cht = item.text
          }
        });
        
        // save_members.push({
        //   id: this.members[j].id,
        //   team_id: this.members[j].team_id,
        //   name_cht: this.members[j].name_cht,
        //   name_eng: this.members[j].name_eng,
        //   job_title_cht: job_title_cht,
        //   job_title_eng: job_title_eng,
        //   img: this.members[j].pic,
        //   del: this.members[j].del
        // })
        await vm.save_members({
          id: vm.members[j].id,
          team_id: vm.members[j].team_id,
          name_cht: vm.members[j].name_cht,
          name_eng: vm.members[j].name_eng,
          email: vm.members[j].email,
          job_title_cht: job_title_cht,
          job_title_eng: job_title_eng,
          img: vm.members[j].pic,
          pic: vm.members[j].name_cht,
          del: vm.members[j].del
        })

        // 進度條
        vm.prossVal = Math.floor(( j / vm.members.length )*100);
        
      }
      // console.log(save_members)
      
      success_members = true;
      // axios
      //   .post(`${process.env.API_PATH}/api/savemembersInfo`,save_members)
      //   .then(res => {
      //     if(res.status == 200){
      //       success_members = true;
      //       if(success_professor && success_members){
      //         vm.$router.push("/about/member");
      //       }
      //     }
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
      if(success_professor && success_members){
        vm.$router.push("/about/member");
      }
      
    },
    // 儲存教授
    async save_professor(save_professor){
        var vm = this;
                
        return new Promise(resolve => {
            axios
              .post(`/api/saveprofessorInfo`,save_professor)
              .then(res => {                  
                  resolve();  // 表示完成
              })
              .catch(err => {
                  console.log(err);
              });
        });
    },
    // 儲存人員
    async save_members(save_members){
        var vm = this;
                
        return new Promise(resolve => {
            axios
              .post(`/api/savemembersInfo`,save_members)
              .then(res => {                  
                  resolve();  // 表示完成
              })
              .catch(err => {
                  console.log(err);
              });
        });
    },
    cancel_edit: function(){
      this.$router.push("/about/member");
    },
    uploadImg: function(e, index, name) {      
      let tag = e.target;
      let fileList = tag.files;
      let imgNum = fileList.length;
      let _this = this;
      _this.imgString = [];   //圖片資料清零
      _this.imgFile = [];     //圖片資料清零
      if (imgNum > this.imgNumLimit) {
        alert("一次最多上傳" + this.imgNumLimit + "張圖片！");
        return;
      }
      var Orientation;
      for (let i = 0; i < imgNum; i++) {
        _this.imgFile.push(fileList[i]);
        EXIF.getData(fileList[i], function() {
          Orientation = EXIF.getTag(fileList[i], "Orientation");
        });
        // file to base64
        let reader = new FileReader();
        reader.readAsDataURL(fileList[i]);
        reader.onload = function() {
          var oReader = new FileReader();
          oReader.onload = function(e) {
            var image = new Image();
            image.src = e.target.result;
            image.onload = function() {

              var expectWidth = this.naturalWidth;
              var expectHeight = this.naturalHeight;
              if (
                this.naturalWidth > this.naturalHeight &&
                this.naturalWidth > 800
              ) {
                expectWidth = 800;
                expectHeight =
                  (expectWidth * this.naturalHeight) / this.naturalWidth;
              } else if (
                this.naturalHeight > this.naturalWidth &&
                this.naturalHeight > 1200
              ) {
                expectHeight = 1200;
                expectWidth =
                  (expectHeight * this.naturalWidth) / this.naturalHeight;
              }
              var canvas = document.createElement("canvas");
              var ctx = canvas.getContext("2d");
              canvas.width = expectWidth;
              canvas.height = expectHeight;
              ctx.drawImage(this, 0, 0, expectWidth, expectHeight);

              // var expectWidth = this.naturalWidth;
              // var expectHeight = this.naturalHeight;
              // var scale = expectWidth / expectHeight;
              // var width_x = 300;
              // var height_x = parseInt(width_x / scale);
              // var canvas = document.createElement("canvas");
              // var ctx = canvas.getContext("2d");
              // canvas.width = width_x;
              // canvas.height = height_x;
              // ctx.drawImage(this, 0, 0, expectWidth, expectHeight, 0, 0, width_x, height_x);

              var base64 = null;
              var formData = new FormData();        
              // formData.append('file', _this.imgFile);   

              base64 = canvas.toDataURL("image/jpeg", 0.8);
              _this.imgString.push({ src: base64 });

              // if (fileList[i].size / 1024000 > 1) {
              //   console.log('行643: 壓縮')
              //   _this.imgScale(base64, 4);
              // } 
              // else {
              //   console.log('行647: 未壓縮')
              //   _this.imgString.push({ src: base64 });
              // }
              

              // formData.append('image_data' + index + name,base64);   
              // console.log(formData.get('image_data' + index + name))
              // console.log(_this.imgFile)

              if(name =='professor'){
                _this.professor[index].pic = _this.imgString[0].src;
              }
              if(name =='members'){
                _this.members[index].pic = _this.imgString[0].src;
              }
              // console.log(JSON.stringify(_this.imgString));
            };
          };
          oReader.readAsDataURL(fileList[i]);
        };
      }
    },
    imgScale: function(imgUrl, quality) {
      let img = new Image();
      let _this = this;
      let canvas = document.createElement("canvas");
      let cxt = canvas.getContext("2d");
      img.src = imgUrl;
      img.onload = function() {
        //縮放後圖片的寬高
        let width = img.naturalWidth / quality;
        let height = img.naturalHeight / quality;
        canvas.width = width;
        canvas.height = height;
        cxt.drawImage(this, 0, 0, width, height);
        _this.imgString.push({ src: canvas.toDataURL("image/jpeg") });
      };
    },
  },
  filters: {
    imgUrl: function(value) {
      if(value != null){
        value = "/static/img/members/" + value + ".jpg";
      }
      else{
        value = "/static/img/placeholder.jpg";
      }
      
      return value;
    },
  },
  computed: {},
  created() {
    this.getprofessorInfo();
    this.getmembersInfo();
  },
  mounted() {
  },
  components: {},
  watch: {}
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/about/edit_member.vue